/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartialUpdateUserInternalRequestOperation } from './partial-update-user-internal-request-operation';


export interface PartialUpdateUserInternalRequestJsonPatchDocument { 
    readonly operations?: Array<PartialUpdateUserInternalRequestOperation> | null;
}

